import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import Grid from '@material-ui/core/Grid/Grid';
import PreviousStep from 'components/Cart/PreviousStep';
import { IProductData, enLang } from 'interfaces/IProductData';
import { cartService } from 'services/CartService';
import Translate from 'components/Translate';
import MultipleInstallments from 'components/Cart/Price/MultipleInstallments';
import WithoutInstallment from 'components/Cart/Price/WithoutInstallment';
import { enStep } from 'components/Cart/Templates/Mobile/MultiStep';
import Coupon from 'components/Cart/Coupon';
import { ICartModel } from 'interfaces/ICartModel';
import { paymentService } from 'services/PaymentService';
import CouponPrice from 'components/Cart/Coupon/CouponPrice';
import { Subscription } from 'components/Cart/Price/Subscription';
import { enPaymentType } from 'enums/enPaymentType';
import { langService } from 'services/LangService';
import FreeShipping from 'components/Cart/Price/FreeShipping';

interface IState extends IStateBase {
  cart: IProductData;
  payment: ICartModel;
  lang: enLang;
  step: enStep;
}

export default class HeaderStep extends BaseComponent<IState> {

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
    this.observeState({ payment: null }, paymentService.getCart());
    this.observeState({ lang: enLang.PT_BR }, langService.getLang());
  }

  render() {

    if (!this.state) {
      return null;
    }

    const { cart, payment, lang } = this.state;
    const numberInstallments = payment.payment[0].numberInstallments;

    return (
      <Grid
        className='header'
        container
        alignItems='center'
      >
        <Grid item xs={6}>
          <PreviousStep step={this.props.step} setStep={this.props.setStep} />
          {this.props.step == enStep.payment
            ? <Coupon />
            : null
          }
        </Grid>
        <Grid item xs={6} className={cart.config.paymentType == enPaymentType.FREE ? 'free' : ''}>
          <CouponPrice />

          {cart.config.paymentType === enPaymentType.FREE
            ? <Translate term={'Gratuito'} />
            : null
          }

          {[enPaymentType.NORMAL, enPaymentType.ECOMMERCE].includes(cart.config.paymentType) && cart.config.paymentType !== enPaymentType.DONATION
            ? numberInstallments > 1 && payment.payment.length == 1 && lang === enLang.PT_BR
              ? <MultipleInstallments cart={cart} />
              : <WithoutInstallment cart={cart} />
            : null
          }

          <FreeShipping config={cart.config} />

          {cart.config.paymentType === enPaymentType.SUBSCRIPTION
            ? <Subscription cart={cart} />
            : null
          }
        </Grid>
      </Grid>
    );
  }
}